import { Field, Formik } from 'formik';
import React, { forwardRef } from 'react';
import { InputField } from '../../../../../components/formFields/InputField';
import { SelectFormField } from '../../../../../components/formFields/SelectFormField';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import { LICENCE } from '../../../../../constants/index';
import { getLicence } from '@/store/selectors/auth';

const dropdownFeed: any[] = [
  { title: 'Ano', id: true },
  { title: 'Ne', id: false },
];

interface ProjectEditFormProps {
  formProps: any;
  submit: (id: any, values: any) => void;
}

const validationSchema = Yup.object().shape({
  title: Yup.string().required('Povinné pole'),
  name_official: Yup.string().required('Povinné pole'),
  identifier: Yup.string().required('Povinné pole'),
});

const ProjectEditForm = forwardRef<any, ProjectEditFormProps>(({ formProps, submit }, ref) => {
  const licence = useSelector(getLicence);
  const isFreeLicence = licence === LICENCE.free.name;

  return (
    <div>
      <Formik
        innerRef={ref}
        validationSchema={validationSchema}
        enableReinitialize
        initialValues={{
          identifier: formProps?.identifier,
          is_active: formProps?.is_active,
          title: formProps?.title,
          name_official: formProps?.name_official,
        }}
        onSubmit={(values) => {
          submit(formProps?.id, values);
        }}
      >
        {(props) => {
          const { values } = props;

          return (
            <div className="space-y-1">
              <Field
                name="title"
                value={values.title}
                placeholder="Název"
                component={InputField}
                label="Název"
                required
                data-testid="project-edit-title-input"
              />
              <Field
                name="name_official"
                value={values.name_official}
                placeholder="Oficiální název"
                component={InputField}
                label="Oficiální název"
                required
                data-testid="project-edit-name-official-input"
              />
              <Field
                name="identifier"
                value={values.identifier}
                placeholder="identifier"
                component={InputField}
                label="Číslo akce"
                required
                data-testid="project-edit-identifier-input"
              />
              {!isFreeLicence && (
                <SelectFormField
                  name="is_active"
                  placeholder=""
                  data={dropdownFeed}
                  label="Aktivní"
                  required
                  data-testid="project-edit-active-select"
                />
              )}
            </div>
          );
        }}
      </Formik>
    </div>
  );
});
ProjectEditForm.displayName = 'ProjectEditForm';

export default ProjectEditForm;
